//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CusDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '80%'
    },
    fillScreen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selfVisible: false
    };
  },
  watch: {
    visible: {
      handler: function handler(val) {
        this.selfVisible = val;
        if (!val) this.initStyle();
      },
      immediate: true
    },
    selfVisible: {
      handler: function handler(val) {
        if (!val) {
          this.$emit('update:visible', val);
          this.initStyle();
        }
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    // 关闭弹框后提示父组件
    close: function close() {},
    initStyle: function initStyle() {
      this.$emit('update:fillScreen', false);
    }
  }
};